import objectFitImages from 'object-fit-images';
import 'lazysizes';
import sectionNav from './components/_sectionNav';
import siteMenu from './components/_siteMenu';
import jobsSearch from './components/_jobsSearch';
import dropdowns from './components/_dropdowns';
import filterAccordions from './components/_filterAccordions';
import shareBtns from './components/_shareBtns';
import sliders from './components/_sliders';
import customCursor from './components/_customCursor';
import modals from './components/_modals';
import scrollAnimations from './components/_scrollAnimations';
import masonryGrids from './components/_masonryGrids';
import hotspots from './components/_hotspots';
import jumpMarks from './components/_jumpMarks';
import maps from './components/_maps';
import tabs from './components/_tabs';
import accordions from './components/_accordions';
import ie from './components/_ie';
import adjustInnerHeight from './components/_adjustInnerHeight';
import scrollBtn from './components/_scrollBtn';
import pageLoad from './components/_pageLoad';
import viewportUnits from './components/_viewportUnits';
import dropdownLinks from './components/_dropdownLinks';
import paginationBlocks from './components/_paginationBlocks';
import anchorBoxes from './components/_anchorBoxes';
import overview from './components/_overview';
import gridCards from './components/_gridCards';
import { touchDevice } from './const';
import testimonialVideo from './components/_testimonialVideo';
import cookieTwoClick from './components/_cookieTwoClick';
import videoSlider from './components/_videoSlider';
import benefitsSlider from './components/_benefitsSlider';

$(() => {
  viewportUnits();
  objectFitImages();
  ie();
  sectionNav();
  siteMenu();
  jobsSearch();
  dropdowns();
  filterAccordions();
  shareBtns();
  sliders();
  customCursor();
  modals();
  masonryGrids();
  hotspots();
  jumpMarks();
  maps();
  tabs();
  accordions();
  scrollAnimations();
  adjustInnerHeight();
  scrollBtn();
  pageLoad();
  dropdownLinks();
  paginationBlocks();
  anchorBoxes();
  overview();
  gridCards();
  testimonialVideo();
  cookieTwoClick();
  videoSlider();
  benefitsSlider();

  if (!touchDevice) {
    $('body').addClass('no-touch');
  }

  $(document).on('lazyloaded', event => {
    objectFitImages(event.target);
  });

  document.addEventListener('ajax', event => {
    setTimeout(
        function() {
          jobsSearch();
          dropdowns();
          masonryGrids();
          // filterAccordions();
          shareBtns();
          // sliders();
          // customCursor();
          masonryGrids();
          hotspots();
          jumpMarks();
          maps();
          tabs();
          accordions();
          scrollBtn();
          dropdownLinks();
          // window.Hyphenator.run();
        }, 1000);
  })
});
